import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Landing page after a social (OAuth) sign-in: pick up the new session and go home. */
const AuthCallback = () => {
  const { refreshSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    refreshSession().then((user) => navigate(user ? '/' : '/login', { replace: true }));
  }, [refreshSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500 text-xs font-bold uppercase tracking-widest">
      Signing you in...
    </div>
  );
};

export default AuthCallback;
